module.exports = "<div class=\"nn-search-button container\"><nn-base-button class=btn ng-click=runTheJewels()><nn-base-svg class=svg icon=\"'loupe'\"></nn-base-svg>{{ item.title | translate }}</nn-base-button></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-modules/nn-search-button/nn-search-button.directive.html
// module id = 1008
// module chunks = 0